<template>
  <div class="alert alert-info" role="alert">
    {{ warningMessage }}
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "WarningComponent",

  computed: {
    ...mapGetters({
      warningMessage: 'getWarningMessage',
    }),
  }

};
</script>

<style scoped>
</style>